export enum FeesDisplayStyle {
  Dollar = "Dollar",
  Percentage = "Percentage",
}
